export const OPEN_CREATE_NOTIFICATION_DIALOG =
  '[CREATE NOTOFICATION DIALOG] OPEN'
export const CLOSE_CREATE_NOTIFICATION_DIALOG =
  '[CREATE NOTOFICATION DIALOG] CLOSE'
export const OPEN_CREATE_NOTIFICATION_DIALOG_FROM_GROUP =
  'OPEN_CREATE_NOTIFICATION_DIALOG_FROM_GROUP'
export const SET_DIALOG_STATE = 'SET_DIALOG_STATE'
export const SET_DRAFT_COUNT = 'SET_DRAFT_COUNT'
export const ON_CREATE_SUCCESS = 'ON_CREATE_SUCCESS'
export const DONT_SHOW_ALERT_DIALOG = 'DONT_SHOW_ALERT_DIALOG'
export const ON_CREATE_DRAFT_SUCCESS = 'ON_CREATE_DRAFT_SUCCESS'
export const UPDATE_FETCH_TIMELINE_FUNCTION = 'UPDATE_FETCH_TIMELINE_FUNCTION'
export const CHANGE_TYPE_DIALOG = 'CHANGE_TYPE_DIALOG'
export const CLEAR_INITAIL_VALUE = 'CLEAR_INITAIL_VALUE'

export function closeDialog() {
  return {
    type: CLOSE_CREATE_NOTIFICATION_DIALOG,
  }
}

export function openDialog(payload) {
  return {
    type: OPEN_CREATE_NOTIFICATION_DIALOG,
    payload,
  }
}

export function updateFetchTimeline(payload) {
  return {
    type: UPDATE_FETCH_TIMELINE_FUNCTION,
    payload,
  }
}
export const setDraftCount = (count) => {
  return { type: SET_DRAFT_COUNT, draftCount: count }
}

export const onCreateNotificationSuccess = () => {
  return { type: ON_CREATE_SUCCESS }
}

export const onCreateDraftNotificationSuccess = () => {
  return { type: ON_CREATE_DRAFT_SUCCESS }
}

export function openDialogFromGroup(payload) {
  return {
    type: OPEN_CREATE_NOTIFICATION_DIALOG_FROM_GROUP,
    payload,
  }
}

export function setDialogState(payload) {
  return {
    type: SET_DIALOG_STATE,
    payload,
  }
}

export function setOpenCreditModal() {
  return {
    type: DONT_SHOW_ALERT_DIALOG,
  }
}

export function onChangeTypeDialog(type) {
  return {
    type: CHANGE_TYPE_DIALOG,
    payload: type,
  }
}

export function clearInitailValue() {
  return {
    type: CLEAR_INITAIL_VALUE,
  }
}
